export default "__VITE_ASSET__ioZ0bzCe__"